import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => (
  <div className="navbar">
    <h2 onClick={() => (window.location.href = "/home")}>Crypto ranking</h2>
    <ul>
      <li>
        <Link to="/home">Home</Link>
      </li>
      <li>
        <Link to="/price-prediction">Price prediction</Link>
      </li>
      <li>
        <Link to="/fng">{"Fear & Greed Meter"}</Link>
      </li>
    </ul>
  </div>
);

export default Navbar;
